import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import TweenMax, {TweenLite} from "gsap";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import * as PIXI from "pixi.js";
import gsap from "gsap";
import Facade from "@/Facade";

export default class FeatureContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.startFeature.add(this.onStartFeature, this)
    Signals.stopFeature.add(this.onStopFeature, this)

    this.activeBullets = []
    this.itemsPool = []

    this.container = new PIXI.Container()
    this.addChild(this.container)

    this.enemy = new SpineAnimation('enemyShip')
    this.container.addChild(this.enemy)
    this.container.position.set(1800, 250)

    this.explosion = new SpineAnimation('ExplosionAnim')
    this.container.addChild(this.explosion)
    this.explosion.visible = false
    this.explosion.x -= 50

    this.visible = false
  }

  onStartFeature() {
    this.isFeatureStopped = false
    this.explosion.visible = false
    this.explosion.stop()
    this.visible = true
    TweenMax.to(this.container, 1, {x: 1000, y: 240})
    this.enemy.start(['forward', 'idle'], [false, true])
    Facade.soundManager.play('jet2_game_boss_intro', 0.8)
    Facade.soundManager.play('jet2_VO_BossIntro', 0.6)
    this.delayedCallShooting = TweenLite.delayedCall(1.5, () => {
      this.enemy.start(['hitAttack'], [true])
    })

    this.shootingInterval = window.setInterval(() => {
      if (this.isShooting) {
        Facade.soundManager.play('jet2_game_boss_attack', 0.4)
      } else {
        clearInterval(this.shootingInterval)
      }
    }, 800)

    this.isShooting = true
  }

  onRoundEnd() {
    this.enemy.start(['idle'], [true])

    if (this.delayedCallShooting) {
      this.delayedCallShooting.kill();
    }
    clearTimeout(this.winTimeout)
    if (this.isFeatureStopped) {
      return
    }
    this.isShooting = false
    //  this.explosion.visible = false
    // this.enemy.start(['idle'], [false])
  }

  onMakeBets() {
    TweenMax.killTweensOf(this.enemy)
    this.container.position.set(1800, 250)
    this.visible = false
  }

  onStopFeature(currentBonus) {
    if (this.isFeatureStopped) {
      return
    }

    let animation = 'explosion'

    if (currentBonus.tp === "multiplier" && currentBonus.v === 1) {
      animation = 'backward'
    }

    this.isFeatureStopped = true
    this.delayedCallShooting.kill();
    this.explosion.visible = false

    if (animation === 'backward') {
      Facade.soundManager.play('jet2_game_boss_escape', 0.6, false)
      this.enemy.start([animation], [false])
      const px = this.enemy.x
      gsap.to(this.enemy, 1.5, {
        x: "+=500", angle: "+=20", onComplete: () => {
          this.enemy.x = px
          this.enemy.angle = 0

          TweenMax.killTweensOf(this.enemy)
          this.container.position.set(1800, 250)
          this.visible = false
          this.explosion.stop()

        }
      })
    } else if (animation === 'explosion') {
      Facade.soundManager.play('jet2_game_boss_death', 0.6, false)
      this.enemy.start([animation], [false])
      this.explosion.visible = true
      //    this.explosion.position.set(this.container.position.x, this.container.position.y)
      this.explosion.start(['ExplosionBattleHeli'], [false])

      this.winTimeout = setTimeout(() => {
        TweenMax.killTweensOf(this.enemy)
        this.container.position.set(1800, 250)
        this.visible = false
        this.explosion.stop()
      }, 2500)
    }

    this.isShooting = false
  }


}
